import React, { FC } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../constants/aampeTheme';
import ICONS from '../../../constants/icons';

const HeroRecommendationEmptyState: FC = () => {
    return (
        <EmptyStateContainer>
            <EmptyState>
                <ICONS.gridNine
                    width={40}
                    height={40}
                    color={aampeTheme.colors.neutral09}
                />
                <EmptyStateText>
                    Create labelled messages to see content coverage
                    opportunities
                </EmptyStateText>
            </EmptyState>
        </EmptyStateContainer>
    );
};

export default HeroRecommendationEmptyState;

const EmptyStateContainer = styled.div({
    borderRadius: aampeTheme.borderRadius.medium,
    border: `1px solid ${aampeTheme.colors.interactiveWG03}`,
    background: aampeTheme.colors.backgroundWG02,
    height: '100%',
    padding: aampeTheme.spacing4(2),
});

const EmptyState = styled.div({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    rowGap: aampeTheme.spacing4(2),
    justifyContent: 'center',
    alignItems: 'center',
});

const EmptyStateText = styled.span({
    color: aampeTheme.colors.neutral09,
    fontWeight: aampeTheme.weights.light,
    textAlign: 'center',
});
